export default __webpack_public_path__ + "static/media/050_brake.vp9.8f636c83.webm";